import React from 'react';

const Section = ({ title, children }) => (
  <section className="mb-10">
    <h2 className="font-display text-2xl text-white mb-3">{title}</h2>
    <div className="text-slate-300 leading-relaxed text-sm space-y-3">{children}</div>
  </section>
);

const Disclaimer = () => (
  <div data-testid="legal-disclaimer-page" className="pt-28 pb-24 max-w-3xl mx-auto px-6 sm:px-12">
    <div className="text-xs uppercase tracking-[0.3em] text-fuchsia-300 mb-3">Legal</div>
    <h1 className="font-display text-4xl font-bold text-white tracking-tight mb-2">Disclaimer</h1>
    <p className="text-slate-500 text-xs mb-10">Last updated: February 13, 2026</p>

    <Section title="1. Information accuracy">
      <p>Artist profiles on Maarivil — including bios, skills, social-media follower counts, pricing, milestones and portfolio — are self-reported by the artists. While we encourage honest representation and remove obviously false content, Maarivil does not independently audit every claim. Always perform your own due-diligence before booking.</p>
    </Section>

    <Section title="2. AI-generated content">
      <p>Several features (AI Portfolio Builder, AI Talent Search, AI Talent Manager chat) use large-language models. AI outputs can be incorrect or biased. Treat AI suggestions as a starting point, not professional advice. Maarivil is not liable for decisions made solely based on AI-generated content.</p>
    </Section>

    <Section title="3. No professional advice">
      <p>Nothing on Maarivil constitutes legal, financial, tax, immigration, or contractual advice. Artists and clients should consult their own professional advisors for engagements crossing state or national borders.</p>
    </Section>

    <Section title="4. Third-party links and embeds">
      <p>Artist profiles may embed YouTube, Vimeo or Instagram content and list social-media handles. Maarivil does not control or endorse third-party content. Following or contacting users via external platforms is at your own risk and outside of Maarivil&apos;s safeguards.</p>
    </Section>

    <Section title="5. Bookings &amp; performance">
      <p>Maarivil facilitates introductions; it does not perform, manage, or guarantee any artistic engagement. We are not liable for cancellations, no-shows, quality of performance, or any direct or indirect loss arising from bookings.</p>
    </Section>

    <Section title="6. Limitation of liability">
      <p>To the maximum extent permitted by law, Maarivil&apos;s aggregate liability for any claim arising out of or relating to the platform is limited to the amount you paid Maarivil in the 12 months preceding the event giving rise to the claim, or ₹5,000, whichever is greater.</p>
    </Section>

    <Section title="7. Reporting issues">
      <p>If you encounter inaccurate information, copyright issues, harassment, or fraud, email <a className="text-fuchsia-300" href="mailto:support@maarivil.com">support@maarivil.com</a>. We aim to respond within 72 hours.</p>
    </Section>
  </div>
);

export default Disclaimer;
